import { STAGE_CONFIG } from '@/config';

let apiUrlBase = '';
let globalApiUrlBase = '';

export function getUrls() {
  // Local dev override: set VITE_API_BASE_URL=http://localhost:8080
  const envOverride = import.meta.env.VITE_API_BASE_URL as string | undefined;
  if (envOverride) {
    apiUrlBase = envOverride;
    globalApiUrlBase =
      (import.meta.env.VITE_GLOBAL_API_BASE_URL as string) || 'https://global.api-dev.mit.edu';
    return { apiUrlBase, globalApiUrlBase };
  }

  const stage = STAGE_CONFIG.stage;
  let suffix = '';
  if (stage !== 'prod') {
    suffix = stage === 'development' ? '-dev' : stage ? `-${stage}` : '-dev';
  }

  apiUrlBase = `https://parley.api${suffix}.mit.edu`;
  globalApiUrlBase = `https://global.api${suffix}.mit.edu`;

  return { apiUrlBase, globalApiUrlBase };
}
